<template>
   <div class="wrap">
     <mt-header title="输入新的手机号码">
       <router-link to="/more/showinfo" slot="left">
         <span class="quxiao">返回</span>
       </router-link>
     </mt-header>
     <!--<div class="main">-->
       <!--<span class="tip" v-model="phone">短信验证码已发送至{{phone1}}，请注意查收。</span>-->
     <!--</div>-->
     <div class="codeMsg">
       <label class="label">手机号</label>
       <input type="text" v-model="newPhone" placeholder="请输入新的手机号码" class="input" autocomplete="off"
              oninput="if(value.length>11)value=value.slice(0,11)">
     </div>
     <div style="padding: 0 .4rem">
       <mt-button type="primary" size="large" class="btn" @click="codeFinish">完成</mt-button>
     </div>
     <!--新的手机号码输入验证码-->
   </div>
</template>
<script>
import apis from '../../apis/index'
import cloudApi from '../../apis/cloudStorageApi'
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      phone: '',
      phone1: '',
      newPhone: ''
    }
  },
  created () {
    this.phone = JSON.parse(sessionStorage.mobileData).phone
//    this.phone1 = this.phone.substr(0, 3) + '****' + this.phone.substr(7)
  },
  components: {
    Toast
  },
  methods: {
    codeFinish () {
      // 要发送请求
      var _this = this
      apis.request(cloudApi.info, {value: _this.newPhone, type: 3}).then(function (res) {
        JSON.parse(sessionStorage.mobileData).phone = _this.newPhone
        Toast({
          message: '修改成功',
          iconClass: 'icon-success'
        })
        _this.$router.push({path: '/more/showinfo'})
      }).catch(function (error) {
        Toast({
          message: error.response.data.message,
          iconClass: 'icon-error'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../assets/css/variable.scss";
  .wrap {
    padding-top: 1.28rem;
    height: 100%;
    background: #f7f7fa;
  }

  .mint-header {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    background-color: $topbar-background-color;
    font-size: .36rem;
  }

  .quxiao {
    font-size: .32rem;
  }

  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }

  .mint-button-text {
    font-size: .28rem;
  }
  .main {
    padding: .2rem .54rem 0 .29rem;
  }

  .main .tip {
    color: #9b9b9b;
    font-size: .28rem;
    text-align: left;
  }
  .codeMsg {
    /*margin: .86rem 0 .3rem 0;*/
    margin: .2rem 0 .3rem 0;
    background-color: #ffffff;
    position: relative;
    /*border-bottom: 1px solid #e5e5e5;*/
    height: .9rem;
    line-height: .9rem;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 .3rem;
    box-shadow: inset 0 -1px 0 0 #e5e5e5, inset 0 1px 0 0 #e5e5e5;
  }
  .input {
    display: inline-block;
    font-size: .28rem;
    border: 0;
    border-radius: 0;
    position: absolute;
    top: .25rem;
    outline: 0;
    color: #9b9b9b;
  }

  .label {
    font-size: .28rem;
    width: 1.02rem;
    text-align: left;
    display: inline-block;
    color: #1d1f22;
    margin-right: .2rem;
  }
  .mint-button--primary {
    background: #E4393C;
  }

  .btn {
    height: .94rem;
    line-height: .94rem;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/acceptcode.vue